/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function FindingContentOutdated({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M7.172.4a2.6 2.6 0 0 1 1.838.761l4.829 4.83a2.6 2.6 0 0 1 .76 1.837v1.42L12.849 11l1.752 1.752V13a2.6 2.6 0 0 1-2.6 2.6H4A2.6 2.6 0 0 1 1.4 13V8.29l.131-.165L3.231 6l-1.7-2.125-.13-.164V3A2.6 2.6 0 0 1 4 .4zM4 1.6A1.4 1.4 0 0 0 2.6 3v.288L4.769 6l-2.17 2.71V13A1.4 1.4 0 0 0 4 14.4h8c.696 0 1.27-.508 1.379-1.173l-1.803-1.803-.425-.424.425-.424L13.4 8.752v-.924q-.001-.115-.02-.228H10A2.6 2.6 0 0 1 7.4 5V1.62a1.4 1.4 0 0 0-.228-.02zM8.6 5A1.4 1.4 0 0 0 10 6.4h2.552L8.6 2.448z" /></svg>;
}
;